/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import _ from 'lodash';
import * as actionTypes from './actionTypes';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';
//  error msg dispatch function
export const dispatchErrorMsgCms = (data) => ({
  type: actionTypes.GET_ERROR_MSG_CMS_DRUG,
  payload: data,
});
// error message for 5 sec for no data exists
export const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
  //   dispatch(dispatchErrorMsgCms([]));
  // }, 5000);
  dispatch(
    dispatchErrorMsgCms([
      {
        field: 'noData',
        message: NO_DATA,
      },
    ])
  );
};
//dispatch quarter
export const dispatchFrom = (data) => ({
  type: actionTypes.GET_FROM_CMS_DRUG,
  payload: data,
});
//dispatch for cms drug
export const dispatchQuarterlyCms = (data) => ({
  type: actionTypes.GET_QUARTERLY_CMS_DRUG_DATA,
  payload: data,
});
export const getQuarterlyCms = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_QUARTERLY_CMS_DRUG, value)
    .then((response) => {
      if (response.data.quarterlyCmsDrugReportVO.length == 0) {
        dispatch(showNoDataMessage());
      } else {
        dispatch(dispatchQuarterlyCms(response.data));
      }
    })
    .catch((response) => {
      dispatch(dispatchQuarterlyCms([]));
    });
};
//refresh data
export const refreshCMSDrug = () => ({
  type: actionTypes.SET_REFRESH_DATA_DRUG,
  payload: {},
});
export const refreshCMSDrugDisplay = () => ({
  type: actionTypes.REFRESH_DATA_DRUG_DISPLAY,
  payload: {},
});
// dispatch function for tab data for request current Dispute Display screen
export const dispatchPerformResolutionObj = (data) => ({
  type: actionTypes.GET_CURRENT_DISPLAY_OBJ_DRUG,
  screenData: data,
});
